import { useCallback } from 'react';

import type { MeShelfQuery } from '@/api/generated/graphql';
import { ME_SHELF_QUERY } from '@/api/queries/me';
import { useAuthedClient } from '@/api/useAuthedClient';
import type { ShelfEntry } from '@/types/feed';

import { useGraphQLQuery } from './useGraphQLQuery';

interface UseShelfReturn {
  entries: ShelfEntry[];
  history: ShelfEntry[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export function useShelf(): UseShelfReturn {
  const authedClient = useAuthedClient();

  const { data, isLoading, error, refetch } = useGraphQLQuery<MeShelfQuery>({
    fetcher: (signal) =>
      authedClient.request<MeShelfQuery>({
        document: ME_SHELF_QUERY,
        signal,
      }),
    deps: [],
  });

  const wrappedRefetch = useCallback(async () => {
    await refetch();
  }, [refetch]);

  const me = data?.me;

  return {
    entries: me?.shelf ?? [],
    history: me?.shelfHistory ?? [],
    isLoading,
    error,
    refetch: wrappedRefetch,
  };
}
